module.exports = __webpack_public_path__ + "img/bg.6fa72e0d.png";